export const socketEventsHandlerDelays = {
  betsClosedDelay: 4000,
  roundStartDelay: 2000,
  doBetResultDelay: 4000,
  firstResultReportDelay: 5000,
  secondResultReportDelay: 12000,
  thirdResultReportDelay: 17000,
  roundFinDelay: 5000,
};
